import { useLayoutEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Commentable } from '@/shared/comments/Commentable';
import { ChatShell } from '@/versions/v1/chrome/chat/ChatShell';
import { useChat } from '@/versions/v1/shared/ChatContext';
import { projectTileBySlug } from '@/versions/v1/shared/project-seed';

export function ProjectChatScene() {
  const { projectId } = useParams<{ projectId: string }>();
  const project = projectTileBySlug(projectId);
  const { selectThread, newChat, threads } = useChat();

  const latestProjectThreadId = useMemo(() => {
    const rows = threads.filter((t) => t.projectSlug === projectId);
    if (rows.length === 0) return null;
    return rows.reduce((a, b) => (b.updatedAt > a.updatedAt ? b : a)).id;
  }, [threads, projectId]);

  useLayoutEffect(() => {
    if (latestProjectThreadId) {
      selectThread(latestProjectThreadId);
    } else {
      newChat(projectId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestProjectThreadId]);

  return (
    <Commentable name="ProjectChatScene">
      <ChatShell
        layout="chat-home"
        helpDoc="workspace/project-chat"
        helpLabel="Project assistant"
        scopeLabel={project ? `Scoped to ${project.name}` : undefined}
        storageKey={`mock-ui:project-chat-files:${projectId ?? 'unknown'}`}
      />
    </Commentable>
  );
}
